<div class="custom_fields_block">
  <div class="overlay_layer" (click)="onOpenFieldsManager()"></div>
  <h4>Custom Fields</h4>
  <board-fields-manager *ngIf="isFieldManagerVisible" (close)="onCloseFieldsManager()" [isNotGuest]="true" [board]="board"></board-fields-manager>
  <div>
    <p>Open Fields Manager</p>
  </div>
</div>
